import { COMMON_AXISLABEL_FORMATTER } from './base';
export var GE_THEME = {
  // 背景色
  DM_BACKGROUND_COLOR: '#DFEFFF',
  // 主题色
  GE_COLOR: ['#637BC0', '#5DADFF', '#37C9C9', '#47C947', '#B6DF3A', '#FFD028', '#FF9D3C ', '#F4794F', '#EA4D4E', '#F47997', '#9F8ED4', '#7D74EA', '#52527D'],
  // 图例
  GE_LEGEND: {
    type: 'plain',
    icon: 'circle',
    right: 20,
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 20,
    padding: [20, 0],
    itemStyle: {
      opacity: 1
    },
    textStyle: {
      color: 'rgba(0, 0, 0, 0.9)',
      fontSize: 12,
      lineHeight: 18,
      padding: [0, 0, 0, 5]
    }
  },
  // tooltip
  GE_TOOLTIP: {
    show: true,
    confine: true,
    trigger: 'axis',
    backgroundColor: 'rgba(76, 83, 92, 0.95)',
    borderWidth: 0,
    borderRadius: 2,
    textStyle: {
      color: 'rgba(255, 255, 255, 100)'
    }
  },
  // 轴文本样式
  GE_AXISLABEL: {
    show: true,
    margin: 12,
    color: 'rgba(0, 0, 0, 0.4)',
    formatter: COMMON_AXISLABEL_FORMATTER
  },
  // 参考线样式
  GE_SPLITLINE: {
    lineStyle: {
      type: 'dashed',
      color: 'rgba(0, 0, 0, 0.1)'
    }
  },
  // 指示线样式
  GE_AXISPOINTER: {
    type: 'line',
    lineStyle: {
      type: 'solid',
      color: '#EAEBEC'
    },
    z: 0
  },
  // 坐标轴名称的文字样式
  GE_NAMETEXTSTYLE: {
    color: 'rgba(0, 0, 0, 0.4)'
  }
};